/**
 * App-like behaviour on every page (console and the public pay page):
 * - no zoom: pinch / double-tap on phones (iOS ignores user-scalable=no, so Safari's gesture events are cancelled too),
 *   ctrl/cmd + wheel and ctrl/cmd + plus/minus/0 on desktop;
 * - no right-click / long-press menu, except in fields (paste must keep working); values meant to be copied have a copy button;
 * - a focused field is scrolled above the on-screen keyboard once it has opened.
 */
const editable = (el: EventTarget | null) =>
  el instanceof HTMLElement && !!el.closest("input, textarea, select, [contenteditable=''], [contenteditable='true']");

export function installAppFeel() {
  const opts = { passive: false } as const;
  const cancel = (e: Event) => e.preventDefault();

  for (const type of ["gesturestart", "gesturechange", "gestureend"]) document.addEventListener(type, cancel, opts);
  document.addEventListener("touchmove", (e) => { if (e.touches.length > 1) e.preventDefault(); }, opts);
  window.addEventListener("wheel", (e) => { if (e.ctrlKey || e.metaKey) e.preventDefault(); }, opts);
  window.addEventListener("keydown", (e) => {
    if ((e.ctrlKey || e.metaKey) && ["+", "=", "-", "_", "0"].includes(e.key)) e.preventDefault();
  });

  document.addEventListener("contextmenu", (e) => { if (!editable(e.target)) e.preventDefault(); });

  // The keyboard takes a moment to open and shrink the visual viewport; then bring the field into view if it's covered.
  const vv = window.visualViewport;
  document.addEventListener("focusin", (e) => {
    const el = e.target;
    if (!vv || !editable(el) || !matchMedia("(pointer: coarse)").matches) return;
    setTimeout(() => {
      if (document.activeElement !== el) return;
      const r = (el as HTMLElement).getBoundingClientRect();
      if (r.top < vv.offsetTop + 8 || r.bottom > vv.offsetTop + vv.height - 8) (el as HTMLElement).scrollIntoView({ block: "center", behavior: "smooth" });
    }, 350);
  });
}
